// This file is generated automatically
// Don't edit this file directly

import { call, toParams } from './utils'

export let api_origin = '/api'

// GET /api/stats/regions
export function getRegions(input: GetRegionsInput): Promise<GetRegionsOutput & { error?: string }> {
  return call('GET', api_origin + `/stats/regions`)
}
export type GetRegionsInput = {
}
export type GetRegionsOutput = {
  regions: Array<{
    id: number
    code: string
    name: string
    flag: string
    native_names: Array<string>
  }>
}
